import axios from 'axios'

// Get canceled tickets from business
const getAll = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket-canceled/business/${iniDate}/${endDate}`)
  return data
}

export {
  getAll
}
